import { useStoryblokStrings } from '../useStoryblokStrings';

export const useContactFriendStrings = (formType: any) => {
    const contactFriendStrings = useStoryblokStrings('contact-friend');

    const data = {
        tellFriend: {
            title: contactFriendStrings.tell_friend_title,
            description: contactFriendStrings.tell_friend_description,
            message: contactFriendStrings.tell_friend_message,
            response: contactFriendStrings.tell_friend_response,
        },
        challengeFriend: {
            title: contactFriendStrings.challenge_friend_title,
            description: contactFriendStrings.challenge_friend_description,
            message: contactFriendStrings.challenge_friend_message,
            response: contactFriendStrings.challenge_friend_response,
        },
    } as any;

    return { data: data[formType] };
};
